/* eslint-disable flowtype/no-types-missing-file-annotation */
import {connect} from 'react-redux';
import React from 'react';
import {
    TripBoardConfirmation,
    TripBoardsApolloProvider
} from '@homeaway/react-trip-board-button';

import {ListingShape as HitListingShape} from '../Hit/Hit';
// TripBoardConfirmation currently needs to support the same props from State as the heart button
import {mapStateToProps, StateProps} from './TripBoardButton';

type Props = {
    actionLocation: string;
    listing: HitListingShape;
    size?: string;
    isMapHit?: boolean;
} & StateProps;

const TripBoardConfirmationComponent = ({
    abacus,
    actionLocation,
    adultsCount,
    childrenCount,
    endDate,
    isMapHit = false,
    isMobile,
    listing: {propertyMetadata, images, listingId, averageRating, reviewCount},
    petIncluded,
    q: searchTerm,
    siteName,
    size,
    startDate
}: Props) => (
    <TripBoardsApolloProvider listingId={listingId}>
        {(tripBoardsApolloProvider) => (
            <TripBoardConfirmation
                {...tripBoardsApolloProvider}
                abacus={abacus}
                actionLocation={actionLocation}
                adultsCount={adultsCount}
                caretOffset={isMobile ? 22 : 26}
                childrenCount={childrenCount}
                endDate={endDate}
                headline={propertyMetadata && propertyMetadata.headline}
                listingId={listingId}
                petIncluded={petIncluded}
                rating={averageRating}
                reviewCount={reviewCount}
                searchTerm={searchTerm}
                siteName={siteName}
                size={size}
                startDate={startDate}
                thumbnailUrl={images && images[0] && images[0].c9_uri}
                useNativeEventListener={isMapHit}
            />
        )}
    </TripBoardsApolloProvider>
);

export default connect(mapStateToProps)(TripBoardConfirmationComponent);
